var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WrapperFormControl',_vm._b({staticClass:"carousel-selector",class:{
    'd-flex flex-column': !_vm.items.length,
  }},'WrapperFormControl',{
    label: _vm.label,
    tooltip: _vm.tooltip,
    error: _vm.error,
    required: _vm.$attrs.required,
  },false),[_c('Carousel',{class:{ 'flex-grow-1': !_vm.items.length },attrs:{"slot":"control","items":_vm.items,"item-size":_vm.itemSize + 16,"arrow-width":_vm.isLargeGame ? 32 : 24,"empty-text":_vm.emptyText},slot:"control",scopedSlots:_vm._u([{key:"carouselItem",fn:function(ref){
  var item = ref.item;
return _c('div',{staticClass:"w-100 px-3 text-center carousel-selector__item",class:{
        'carousel-selector__item--active': _vm.isActive(item),
      },attrs:{"title":item.name || item.title},on:{"click":function($event){return _vm.setActive(item)}}},[_c(_vm.component,_vm._b({tag:"component",class:{
          'adjust-btn-height': _vm.adjustButton,
          'cursor-default': _vm.readOnly,
          'cursor-pointer': !_vm.readOnly,
        }},'component',_vm.componentProps(item),false)),(!_vm.hideItemTitle)?_c('TextBlock',{staticClass:"mt-3 mb-0 text-truncate",class:{ 'mx-n1': !_vm.isLargeGame },attrs:{"tag":"p","size":_vm.isLargeGame ? 1 : 0.625,"variant":_vm.isActive(item) ? 'primary' : 'secondary',"text":item.name || item.title}}):_vm._e()],1)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }